(function($){


$('.header__nav-button').click(function(){

  $('body').toggleClass('open-menu')

  $('.menu').toggleClass('open')

})

$(document).ready(function() {
  if ($(window).width() < 992) {
    $('.has-submenu>a').click(function(e) {
      e.preventDefault(); // prevent link default behavior if needed
      $(this).next('.submenu').toggle(500);
    });
    $('.has-submenu > a').attr('href', 'javascript:;');
  }
});
  $('.cart-icon').click(function(){

  $('body').addClass('cart-open');
 $('.page-overlay').addClass('active');

})
  $('.close_cart').click(function(){

  $('body').removeClass('cart-open');
   $('.page-overlay').removeClass('active');

})
 if (window.location.search.includes("viewcart=true")) {
    $('body').addClass('cart-open');
 $('.page-overlay').addClass('active');
 }
$('.page-overlay').click(function(){
$('body').removeClass('cart-open')
  $('body').removeClass('open-menu')

  $('.menu').removeClass('open')
})

// $(".g_prod_qty .flex .qty__adjust").on("click", function () {
//   var t,
//       e = $(this),
//       i = e.parents(".g_prod_qty").find("input").val();
//   (t = e.hasClass("qty__adjust--plus") ? parseFloat(i) + 1 : 0 <= i ? parseFloat(i) - 1 : 1), e.parents().find("input").val(t);
// });

$(document).ready(function() {
  $('ul.accordion').accordion();
  $('ul.accordion li a').eq(0).trigger('click');
});





$('.social_slider').slick({

  dots: false,
   arrows: true,
  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",

  slidesToShow:4,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3

      }
    },
    {

      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
        centerMode: true,
    centerPadding: '16px'

      }

    }

  ]

});

  $('.blog-slide').slick({

  dots: false,
   arrows: true,
  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",

  slidesToShow:1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1

      }
    },
    {

      breakpoint: 767,
      settings: {
        slidesToShow: 1

      }

    }

  ]

});

$('.featured_slider').slick({

  dots: false,
   arrows: true,
  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",

  slidesToShow:1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1

      }
    },
    {

      breakpoint: 767,
      settings: {
          dots: true,
          adaptiveHeight: true,
   arrows: false,
        slidesToShow: 1

      }

    }

  ]

});


  $('.product-slide').slick({

  dots: false,
   arrows: true,
  infinite: true,

  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",

  slidesToShow:1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1

      }
    },
    {

      breakpoint: 767,
      settings: {
        slidesToShow: 1

      }

    }

  ]

});

$('.also_like_slide').slick({
  dots: false,
   arrows: false,
  infinite: true,
  prevArrow:"<button type='button' class='slick-prev small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.84087 7.50004L9.60226 2.15191C10.1326 1.65963 10.1326 0.861486 9.60226 0.369206C9.07194 -0.12307 8.21212 -0.123069 7.68181 0.369211L0 7.50004L7.68182 14.6308C8.21213 15.1231 9.07193 15.1231 9.60225 14.6308C10.1326 14.1385 10.1326 13.3404 9.60225 12.8481L3.84087 7.50004Z' fill='Currentcolor'/></svg></button>",
  nextArrow:"<button type='button' class='slick-next small-icon'><svg width='10' height='15' viewBox='0 0 10 15' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M6.15913 7.50005L0.397739 2.15191C-0.132581 1.65963 -0.132579 0.861486 0.397742 0.369207C0.928061 -0.12307 1.78787 -0.123069 2.31819 0.369211L10 7.50005L2.31818 14.6308C1.78787 15.1231 0.928067 15.1231 0.397752 14.6308C-0.132573 14.1385 -0.132573 13.3404 0.397753 12.8481L6.15913 7.50005Z' fill='currentcolor'/></svg></button>",
  slidesToShow:4,
  centerMode: true,
    centerPadding: '127px',
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3

      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow:2,
        centerPadding: '50px'

      }
    },
    {

      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        arrows: false,
        centerMode: true,
    centerPadding: '40px'

      }

    }

  ]

});

$(document).ready(function () {
    $('.amount-buttons button').click(function () {
      // Get the numeric value from the button text (remove the € symbol)
      const value = $(this).text().replace('€', '').trim();

      // Set that value to the input field inside .custom-amount
      $('.custom-amount input[type="number"]').val(value);
    });
  });


$('.tab-menu li a').on('click', function(){

  var target = $(this).attr('data-rel');

$('.tab-menu li a').removeClass('active');

  $(this).addClass('active');

  $("#"+target).fadeIn('slow').siblings(".tab-box").hide();

  return false;

});




$('.blog-imggg > a').each(function(){

  $(this).find('img').hide();

  var _Bg = 'url('+ $(this).find('img').attr('src') + ')';

  $(this).css("background-image", _Bg);

  $(this).find('img').hide();

}); 






















  









})(jQuery);










